import { Pipe, PipeTransform, inject } from '@angular/core';
import { BuilderInfoService } from '@portal/builder';

@Pipe({
  name: 'portalLang',
  standalone: false,
})
export class PortalLangPipe implements PipeTransform {
  private readonly builderInfoService = inject(BuilderInfoService);

  transform(value: Record<string, string>): string | null {
    return value?.[this.builderInfoService.lang];
  }
}
